export const config = {
  // tableType:'antd',
  rowSelection: false,
  columns: [
    {
      title: '订单编号',
      dataIndex: 'orderNo',
      width: 180,
      fixed: 'left',
    },
    {
      title: '商品名称',
      dataIndex: 'goodsName',
      width: 240,
    },
    {
      title: '报价类型',
      dataIndex: 'budgetTypeName',
      width: 120,
    },
    {
      title: '客户姓名',
      dataIndex: 'customerName',
      width: 120,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '客户电话',
      dataIndex: 'customerPhone',
      width: 120,
    },
    {
      title: '所属门店',
      dataIndex: 'shopName',
      width: 120,
    },
    {
      title: '发起人',
      dataIndex: 'creatorName',
      width: 120,
    },
    {
      title: '当前审核节点',
      dataIndex: 'currentAuditNode',
      width: 150,
      render: (val) => <span>{ val || '-' }</span>
    },
    {
      title: '审核状态',
      dataIndex: 'processStateName',
      width: 100,
      render: 'statusRender',
    },
    {
      title: '审核次数',
      dataIndex: 'reviewCount',
      width: 120,
    },
    {
      title: '最近提交时间',
      dataIndex: 'lastSubmitTime',
      itemType: 'dateTime',
      width: 180,
    },
    {
      title: '最近审核时间',
      dataIndex: 'lastAuditTime',
      itemType: 'dateTime',
      width: 180,
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 160,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      label: '客户姓名',
      name: 'customerName',
      type: 'input',
    },
    {
      label: '客户电话',
      name: 'customerPhone',
      type: 'input',
    },
    {
      label: '订单编号',
      name: 'orderNo',
      type: 'input',
    },
    {
      label: '审核状态',
      name: 'processStates',
      itemType: 'select',
      data: 'processStatusEnum',
      labelKey: 'description',
      key: 'key',
      mode: 'multiple',
    },
    {
      name: 'shopIds',
      label: '所属门店',
      itemType: 'select',
      data: 'companyList',
      labelKey: 'name',
      key: 'id',
      mode: 'multiple',
    },
    {
      label: '发起人',
      name: 'creatorName',
      type: 'input',
    },
  ],
  footer: [
  ],
  batchActions: [],
}
